import { gsap } from '../global/gsap';

const initSearch = (wrapper) => {
    const body = document.querySelector('.js-body');
    const searchToggles = document.querySelectorAll('.js-search-button');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'search-open';
    const workingClass = 'working';

    // Fetch bits
    const rootUrl = body.dataset.site ? body.dataset.site : null;
    const searchForm = wrapper.querySelector('.js-search-form');
    const searchInput = wrapper.querySelector('.js-search-input');
    const searchList = wrapper.querySelector('.js-search-list');

    window.searchOpen = false;

    document.addEventListener('click', (event) => {
        // If menu is open and wrapper is clicked, close it
        if (window.searchOpen && event.target === wrapper) {
            window.searchOpen = false;
            body.classList.remove(stopScrollingClass, isActiveClass);
        }

        // If toggle is clicked, do the thing
        if ([...searchToggles].includes(event.target)) {
            event.preventDefault();
            window.searchOpen = !window.searchOpen;

            // Close menu
            if (window.searchOpen) {
                body.classList.remove('menu-open');
                window.menuOpen = false;
            }

            if (window.searchOpen) {
                body.classList.add(stopScrollingClass, isActiveClass);
                searchInput.focus();
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
                searchInput.blur();
            }
        }
    });

    const toggleWorking = (working) => {
        body.classList.toggle(workingClass, working);
    };

    const fetchResults = async (term, popstate = false) => {
        toggleWorking(true);
        searchList.innerHTML = '';
        searchInput.value = term;

        if (!term) {
            toggleWorking(false);
            return;
        }

        const href = `${rootUrl}/?s=${encodeURIComponent(term)}`;

        fetch(href).then((response) => response.text()).then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Get content
            const content = doc.querySelector('.js-search-results');

            if (content) {
                toggleWorking(false);

                // Only update histroy if exists and not fired by popState
                if (history.pushState && !popstate) {
                    history.pushState({}, '', href);
                }

                searchList.innerHTML = '';
                searchList.innerHTML = content.innerHTML;

                const info = searchList.querySelector('.js-search-info');
                const cards = searchList.querySelectorAll('.js-card');

                if (info) {
                    gsap.from(info, {
                        autoAlpha: 0,
                        duration: 0.33
                    });
                }

                if (cards && cards.length > 0) {
                    gsap.from(cards, {
                        autoAlpha: 0,
                        duration: 0.33,
                        stagger: 0.1,
                    });
                }
            }

            return null;
        }).catch((err) => {
            // There was an error, remove any util classes, show error message
            toggleWorking(false);
            searchList.innerHTML = '<p>Sorry something went wrong, please try searching again.</p>';
            console.warn('Something went wrong.', err);
        });
    };

    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const term = searchInput.value;
        fetchResults(term);
    });

    // Do fetch on back/forward, depending on term param
    window.onpopstate = () => {
        const searchParams = new URLSearchParams(event.target.location.search);
        const searchTerm = searchParams.get('s');

        // If searchTerm, fetch it, otherwise close search if open
        if (searchTerm) {
            if (!window.searchOpen) {
                body.classList.add('search-open');
                window.searchOpen = true;
            }

            fetchResults(searchTerm, true);
        } else if (window.searchOpen) {
            body.classList.remove('search-open');
            window.searchOpen = false;
        }
    };
};

export { initSearch as default };
